/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import {
    ICheckoutTermsAndConditions,
    ICheckoutTermsAndConditionsError,
    ICheckoutTermsAndConditionsViewProps
} from './lds-checkout-terms-and-conditions-4';
// @ts-ignore
import { Error } from '@churchofjesuschrist/eden-alert';

interface ILdsCheckoutTermsAndConditions extends ICheckoutTermsAndConditions {
    resources?: any;
    salesAndRefundPolicy?: any;
    context?: any;
}

const TermsAndCondition: React.FC<ILdsCheckoutTermsAndConditions> = ({
    termsAndConditionAcceptance,
    checkBox,
    description,
    salesAndRefundPolicy,
    resources,
    context
}) => {
    const [title, setTitle] = React.useState<any>();

    React.useEffect(() => {
        const sessionTitle = sessionStorage.getItem('salesData');

        if (!title) {
            setTitle(sessionTitle);
        }
    }, []);

    // const linkURL = salesAndRefundPolicy?.URL.replace('%1', salesAndRefundPolicy.LDSPublisherLanguage).replace(
    //     '%2',
    //     salesAndRefundPolicy.LDSPublisherCountry
    // );
    const onClick = async (policyType: string) => {
        const encodedString = encodeURIComponent(policyType);

        window.open(`${window.location.origin}${context.request.sitePath}/termsandconditions?policy=${encodedString}`);
    };

    return (
        <Node {...termsAndConditionAcceptance}>
            {checkBox}
            {/* {description} */}
            <div>
                {`${resources.agreementText} `}
                <a
                    className='termAndCondition'
                    onClick={() =>
                        salesAndRefundPolicy && salesAndRefundPolicy.PolicyType ? onClick(salesAndRefundPolicy.PolicyType) : ''
                    }
                    target='_blank'
                    rel='noreferrer'
                    style={{ cursor: 'pointer' }}
                >
                    {title || salesAndRefundPolicy?.DESCRIPTION || salesAndRefundPolicy?.Description}
                </a>
            </div>
        </Node>
    );
};

const ErrorMessage: React.FC<ICheckoutTermsAndConditionsError> = ({ error, title, message }) => {
    return (
        // <Node {...error}>
        // @ts-ignore
        <Error style={{ padding: '0px' }}>{message.props.message}</Error>
        // </Node>
    );
};

const CheckoutTermsAndConditionsView: React.FC<ICheckoutTermsAndConditionsViewProps> = props => {
    const {
        checkoutTermsAndConditions,
        checkoutErrorRef,
        viewState,
        termsAndConditionsContent,
        errorMessage,
        saveButton,
        editButton,
        cancelButton,
        salesAndRefundPolicy,
        resources
    } = props;

    return (
        // TODO: All wrapper div should be provided by viewProps. Once SDK provide the sln, update markup.
        <Module {...checkoutTermsAndConditions} ref={checkoutErrorRef}>
            {viewState.isError && errorMessage && <ErrorMessage {...errorMessage} />}
            <TermsAndCondition
                {...termsAndConditionsContent}
                salesAndRefundPolicy={salesAndRefundPolicy}
                resources={resources}
                context={props.context}
            />
            {viewState.isShowSaveButton && saveButton}
            {viewState.isShowEditButton && editButton}
            {viewState.isShowCancelButton && cancelButton}
        </Module>
    );
};

export default CheckoutTermsAndConditionsView;
